import { v4 as uuidv4 } from 'uuid';

import { Component, h, Host, Prop, State, Watch } from '@stencil/core';

import { animateValue } from './animationHelper';
import { NumberFormatList, NumberFormatStyle } from './numberFormats';
import { inViewport } from './viewIntersectionHelper';

@Component({
  tag: 'pn-stats-info-data',
  styleUrl: 'pn-stats-info-data.scss',
})
export class PnStatsInfoData {
  @Prop() format: string = 'En';
  @Prop() formatStyle: string = 'Decimal';
  @Prop() startValue: number = 0;
  @Prop() data: number = 0;
  @Prop() unit: string = null;
  @Prop() preamble: string = null;
  @Prop() duration?: number = 1000; //ms;
  @Prop() index: number = null;

  @State() hasBeenShown: boolean = false;
  @State() compId: string = null;

  inViewPortCallback = (entry: IntersectionObserverEntry) => {
    if (entry.isIntersecting) {
      this.hasBeenShown = true;
    }
  };

  generateUniqueId() {
    return uuidv4();
  }

  componentWillLoad() {
    this.compId = this.generateUniqueId();
  }

  @Watch('hasBeenShown')
  watchStateHandlder(newValue: boolean, oldValue: boolean) {
    const obj = document.getElementById(`pn-stats-info-data-${this.compId}-${this.index}`);
    if (obj.classList.contains('is-inViewport') && newValue !== oldValue) {
      animateValue(obj, this.startValue, this.data, this.duration, NumberFormatList[this.format].code, NumberFormatStyle[this.formatStyle]);
    }
  }

  render() {
    return (
      <Host>
        <div class="pn-stats-info-data__container">
          <div class="pn-stats-info-data__container__content">
            <div class="pn-stats-info-data__container__content__data" id={`pn-stats-info-data-${this.compId}-${this.index}`}></div>
            {this.unit && <div class="pn-stats-info-data__container__content__unit">{this.unit}</div>}
          </div>
          <div class="pn-stats-info-data__container__content__preamble">{this.preamble}</div>
        </div>
      </Host>
    );
  }

  componentDidRender() {
    const observer = new IntersectionObserver(entries => inViewport(entries, 'is-inViewport', this.inViewPortCallback));
    const obj = document.getElementById(`pn-stats-info-data-${this.compId}-${this.index}`);
    observer.observe(obj);
  }
}
